import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material"
import React, { useCallback, useContext, useState } from "react"
import { GroupLevel } from "../../../context/GroupLevel"
import { levelNumberToLabel } from "../../../../../../../../../../../core/services/helper-service"
import { EnumRadioButton } from "../../../../../../../../../../../components/inputs/radio-button-input/EnumRadioButton"
import CancelButton from "../../../../../../../../../../../components/buttons/CancelButton/CancelButton"
import { ValidateButton } from "../../../../../../../../../../../components/buttons/ValidateButton/ValidateButton"
import { BSLevelFormContext } from "../../../context/BSLevelFormContext"

interface IProps {
  groupLevel: GroupLevel
  isSuperstructure: boolean
  groupOptionsToDisplay: GroupLevel[]
  setGroupOptionsToDisplay: React.Dispatch<React.SetStateAction<GroupLevel[]>>
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export function MergeGroupLevelDialog({
  groupLevel,
  isSuperstructure,
  groupOptionsToDisplay,
  setGroupOptionsToDisplay,
  isOpen,
  setIsOpen,
}: Readonly<IProps>): React.JSX.Element {
  const { mergeGroupLevels } = useContext(BSLevelFormContext)

  const [selectedGroup, setSelectedGroup] = useState<GroupLevel>(groupOptionsToDisplay[0])

  const handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void = useCallback(
    (e) => {
      const selected = groupOptionsToDisplay.find((group) => group.id === e.target.value)
      if (selected) {
        setSelectedGroup(selected)
      }
    },
    [groupOptionsToDisplay]
  )

  const handleMergeGroupLevels: () => void = useCallback(() => {
    mergeGroupLevels(groupLevel, selectedGroup, isSuperstructure)
  }, [groupLevel, isSuperstructure, mergeGroupLevels, selectedGroup])

  const handleClose: () => void = useCallback(() => {
    setIsOpen(false)
    setGroupOptionsToDisplay([])
  }, [setGroupOptionsToDisplay, setIsOpen])

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>{`Sélectionner le niveau ou le groupe de niveaux auquel rattacher le niveau ${levelNumberToLabel(
        groupLevel.levelList[0].levelNumber
      )}.`}</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <EnumRadioButton
              id="groupLevel"
              label="Niveau/Groupe de niveaux"
              value={selectedGroup.id}
              options={groupOptionsToDisplay.map((group) => ({
                label:
                  group.levelList.length > 1
                    ? `${levelNumberToLabel(group.levelList[0].levelNumber)};${levelNumberToLabel(
                        group.levelList[group.levelList.length - 1].levelNumber
                      )}`
                    : levelNumberToLabel(group.levelList[0].levelNumber),
                value: group.id,
              }))}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>
          {/* ))} */}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Box sx={{ px: 1 }}>
          <CancelButton onClick={handleClose} label="Annuler" />
        </Box>
        <ValidateButton onClick={handleMergeGroupLevels} label="Confirmer" />
      </DialogActions>
    </Dialog>
  )
}
